__webpack_require__.p = "https://cdn.n-tv.de/sport/0.65.2/_next/";